import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Removed unused Link import
import { AuthContext } from '../contexts/AuthContext';

const ThankYou = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="container">
      <h1>Thank You!</h1>
      <div className="success-message">
        Your application has been submitted successfully.
      </div>
      <p>
        We've received your staff application for KusoduWalls. Our team will review your submission and contact you through Discord if we'd like to proceed with your application.
      </p>
      <p>
        Please ensure your Discord privacy settings allow messages from server members so we can reach you.
      </p>
      <div style={{ display: 'flex', gap: '20px', marginTop: '30px' }}>
        <button onClick={handleLogout} className="discord-login-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
